import { FavoriteAddress, GeocodeSuggestion } from "./types";

export function parseFavoriteAddressesResponse(data: unknown): FavoriteAddress[] {
  const arr = Array.isArray(data) ? data : (data as { data?: unknown })?.data ?? [];

  if (!Array.isArray(arr)) return [];

  return arr
    .map((item): FavoriteAddress | null => {
      const record = item as Record<string, unknown>;
      const id = Number(record.id);
      const userId = Number(record.user_id);
      const addressName = String(record.address_name ?? "").trim();
      const lat = parseFloat(String(record.lat ?? ""));
      const lng = parseFloat(String(record.lng ?? ""));

      if (!id || !userId || !addressName || Number.isNaN(lat) || Number.isNaN(lng)) {
        return null;
      }

      return {
        id,
        user_id: userId,
        address_name: addressName,
        lat,
        lng,
      };
    })
    .filter((item): item is FavoriteAddress => item != null);
}

export function filterFavoriteAddressesByUserId(
  addresses: FavoriteAddress[],
  userId: number | null | undefined
): FavoriteAddress[] {
  if (!userId) return [];
  return addresses.filter((address) => address.user_id === userId);
}

export const MAX_EMPTY_FAVORITE_ADDRESSES = 5;

export function filterFavoriteAddressesByQuery(
  addresses: FavoriteAddress[],
  query: string
): FavoriteAddress[] {
  const normalizedQuery = query.trim().toLowerCase();
  if (normalizedQuery.length < 2) return [];

  return addresses.filter((address) =>
    address.address_name.toLowerCase().includes(normalizedQuery)
  );
}

export function getVisibleFavoriteAddresses(
  addresses: FavoriteAddress[],
  query: string,
  emptyLimit = MAX_EMPTY_FAVORITE_ADDRESSES
): FavoriteAddress[] {
  const trimmedQuery = query.trim();

  if (trimmedQuery.length === 0) {
    return addresses.slice(0, emptyLimit);
  }

  return filterFavoriteAddressesByQuery(addresses, trimmedQuery);
}

export function favoriteAddressToGeocodeSuggestion(address: FavoriteAddress): GeocodeSuggestion {
  return {
    formattedAddress: address.address_name,
    lat: address.lat,
    lng: address.lng,
  };
}
